import * as React from 'react'
import { Mercator } from '@vx/geo'
import { AustraliaGeoJson } from './AustraliaGeoJson'
import * as colors from 'styles/colors-export.css'
import { flow, values, max, round, sum } from 'lodash'
import { scaleLinear } from '@vx/scale'
import { withTooltip } from '@vx/tooltip'
import { localPoint } from '@vx/event'
import { GraphTooltip } from '../GraphTooltip'
import LinedTable from 'components/Tables/LinedTable'

export interface IGraphAustraliaProps {
  data: {
    nsw: number
    vic: number
    qld: number
    sa: number
    wa: number
    tas: number
    nt: number
    act: number
    ukn: number
  }
  width: number
  height: number
}

const getMax = flow(values, max)
const getSum = flow(values, sum)

export const GraphAustraliaComponent = ({
  width,
  height,
  data,
  tooltipData,
  tooltipLeft,
  tooltipTop,
  tooltipOpen,
  hideTooltip,
  showTooltip,
}) => {
  if (width < 10) return <div />

  const dataMax = getMax(data)
  const dataSum = getSum(data)

  const opacityScale = scaleLinear({
    range: [0.5, 1],
    domain: [0, dataMax],
  })

  const handleTooltip = feature => event => {
    const coords = localPoint(event.target.ownerSVGElement, event)
    showTooltip({
      tooltipLeft: coords.x,
      tooltipTop: coords.y,
      tooltipData: {
        label: feature.properties.name,
        value: data[feature.properties.code],
      },
    })
  }

  const ratio = width / 640

  return (
    <div>
      <svg width={width} height={height}>
        <Mercator
          data={AustraliaGeoJson.features}
          scale={600 * ratio}
          translate={[-1080 * ratio, -100 * ratio]}
          fill={feature => colors.tertiary}
          opacity={feature => opacityScale(data[feature.properties.code])}
          stroke={() => colors.tertiary}
          onMouseOver={handleTooltip}
          onTouchStart={handleTooltip}
          onTouchMove={handleTooltip}
          onMouseMove={handleTooltip}
          onMouseLeave={data => event => hideTooltip()}
        />
      </svg>
      {tooltipOpen && (
        <GraphTooltip top={tooltipTop} left={tooltipLeft}>
          <LinedTable>
            <div>
              <div>Name:</div>
              <div>{tooltipData.label}</div>
            </div>
            <div>
              <div>Calls:</div>
              <div>{tooltipData.value}</div>
            </div>
            <div>
              <div>Ratio:</div>
              <div>{round((tooltipData.value / dataSum) * 100, 2)}%</div>
            </div>
          </LinedTable>
        </GraphTooltip>
      )}
    </div>
  )
}

export const GraphAustralia = withTooltip(GraphAustraliaComponent) as React.SFC<
  IGraphAustraliaProps
>



// WEBPACK FOOTER //
// src/features/CallAnalytics/GraphAustralia/GraphAustralia.tsx